module.exports = __webpack_public_path__ + "img/Proliferation-OSCC_GSE208253.1c266f1b.png";